/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable indent */


import { format } from 'date-fns';
import i18next from 'i18next';

export interface TokenProps {
  given_name: string;
  preferred_username: string;
}

// export const convertDate = (date: Date | string) => {
//   return date && format(new Date(date), "yyyy-MM-dd'T'HH:mm:ss");
// };

export const convertDate = (date: Date | string) => {
  if (!date) return;

  const newDate = new Date(date);

  if (!newDate || !newDate?.getTime()) return;

  return date && format(new Date(date), "yyyy-MM-dd'T'HH:mm:ss");
};

export const hasToken = () => {
  if (typeof window === 'undefined') return;
  const { pathname } = window.location;
  if (pathname.includes('/Public')) {
    return false;
  }
  return true;
};

export const apiService = (api = process.env.NEXT_PUBLIC_BASE_API_URL_SP) => {
  if (typeof window === 'undefined') return;
  const { pathname } = window.location;
  if (!hasToken() || pathname.includes('/Public'))
    return api + 'user-not-logged/';
  return api;
};

// eslint-disable-next-line  @typescript-eslint/no-explicit-any
export const NotificationCreateBody = (data: any) => {
  const testIfIsAPerson = /true/.test(data?.person?.inputValue);
  const testHospitalCare =
    testIfIsAPerson &&
    data?.hospitalCare &&
    data?.personType?.inputValue === '1';
  const testPersonId =
    data?.noId || (testIfIsAPerson && data?.personType?.inputValue !== '1');

  const questions = data?.questions
    ? data?.questions.map((question: any) => {
      if (Array.isArray(question)) {
        const questionGroups = question.map((questionGroup: any) => {
          if (questionGroup.questionTypeId === 5) {
            if (Array.isArray(questionGroup?.inputValue)) {
              const questionData = questionGroup?.inputValue.map(
                (checkBoxValues: string) => {
                  return {
                    QuestionId: questionGroup?.questionId,
                    Answer: null,
                    AnswerId: Number(checkBoxValues),
                    QuestionLibrary: questionGroup?.questionsLibrary,
                    groupId: questionGroup?.groupId
                      ? Number(questionGroup?.groupId)
                      : 0,
                  };
                },
              );
              return questionData;
            }
          } else {
            const questionData = {
              QuestionId: questionGroup?.questionId,
              Answer:
                questionGroup?.answers &&
                  questionGroup?.answers.length === 0 &&
                  questionGroup?.inputValue
                  ? Array.isArray(questionGroup?.inputValue)
                    ? questionGroup?.inputValue[0]
                    : questionGroup?.inputValue
                  : null,
              AnswerId:
                questionGroup?.answers &&
                  questionGroup?.answers.length > 0 &&
                  questionGroup?.inputValue
                  ? Number(questionGroup?.inputValue)
                  : null,
              QuestionLibrary: questionGroup?.questionsLibrary,
              groupId: questionGroup?.groupId
                ? Number(questionGroup?.groupId)
                : 0,
            };
            return questionData;
          }
        });
        return [...questionGroups.flat()];
      }

      if (question.questionTypeId === 5) {
        if (Array.isArray(question?.inputValue)) {
          const questionData = question?.inputValue.map(
            (checkBoxValues: string) => {
              return {
                QuestionId: question?.questionId,
                Answer: null,
                AnswerId: Number(checkBoxValues),
                QuestionLibrary: question?.questionsLibrary,
              };
            },
          );
          return questionData;
        }
      }
      return {
        QuestionId: question?.questionId,
        Answer:
          question?.answers &&
            question?.answers.length === 0 &&
            question?.inputValue
            ? Array.isArray(question?.inputValue)
              ? question?.inputValue[0]
              : question?.inputValue
            : null,
        AnswerId:
          question?.answers &&
            question?.answers.length > 0 &&
            question?.inputValue
            ? Number(question?.inputValue)
            : null,
        QuestionLibrary: question?.questionsLibrary,
      };
    })
    : [];

  const questionNormalized = questions.flat().filter((question: any) => question.QuestionId);


  return {
    ...data,
    hospitalCare: testHospitalCare ? data?.hospitalCare : undefined,
    shiftId: Number(data?.notificationMoreInfoInput?.inputValue),
    genderId: data?.genderId?.inputValue
      ? Number(data?.genderId?.inputValue)
      : 3,
    placeOfOccurrenceId: 1, // @TODO - Falta rever esses dados
    // placeOfOccurrenceId: data?.placeOfOccurrenceId,
    notificationRefersToId:
      testIfIsAPerson && data?.personType?.inputValue
        ? Number(data?.personType?.inputValue)
        : 4,
    patientName: testIfIsAPerson ? data?.patientName : undefined,
    person: testIfIsAPerson,
    personType: data?.personType?.inputValue
      ? Number(data?.personType?.inputValue)
      : null,
    patientIdentification:
      testIfIsAPerson && testPersonId ? data?.patientIdentification : undefined,
    patientBirthDate:
      testIfIsAPerson && testPersonId && data?.patientBirthDate
        ? convertDate(data?.patientBirthDate)
        : undefined,
    date: data?.notificationIntubationDateId,
    notificationIntubationDateId: null,
    hospitalAdmissionId: data?.hospitalAdmissionId,
    unitAdmissionId: data?.unitAdmissionId,
    unitId: Number(data?.unitId?.inputValue),
    notificationTypeId: Number(data?.notificationTypeId?.inputValue),
    notificationCategoryId: Number(data?.notificationCategoryId?.inputValue),
    notificationIncidentId: Number(data?.notificationIncidentId?.inputValue),
    notificationOptionId: Number(data?.notificationOptionId?.inputValue),
    descriptionIncident: data?.descriptionIncident,
    descriptionActionAfterIncident: data?.descriptionActionAfterIncident,
    patientOrFamilyKnow:
      data?.patientOrFamilyKnow?.inputValue === 'NA'
        ? null
        : /true/.test(data?.patientOrFamilyKnow?.inputValue),
    thereWasNegativeDemonstration:
      !data?.thereWasNegativeDemonstration ||
        data?.patientOrFamilyKnow?.inputValue === 'NA'
        ? null
        : /true/.test(data?.thereWasNegativeDemonstration?.inputValue),
    witnessSignalingLegalCompanySocialMediaByFamily:
      !data?.witnessSignalingLegalCompanySocialMediaByFamily ||
        data?.patientOrFamilyKnow?.inputValue === 'NA'
        ? null
        : /true/.test(
          data?.witnessSignalingLegalCompanySocialMediaByFamily?.inputValue,
        ),
    whoWasNotified: data?.whoWasNotified,
    safetyHuddleOrProactiveAction: data?.safetyHuddleOrProactiveAction,
    prioritizationId: data?.prioritizationId,
    incidentDamageId: data?.incidentDamageId,
    notifierId: data?.notifierId,
    notifierName: data?.notifierName,
    notifierEmail: data?.notifierEmail,
    notifierUnitId: Number(data?.notifierUnitId?.inputValue),
    occupationId: Number(data?.occupationId?.inputValue),
    notificationMoreInfoInput: Number(
      data?.notificationMoreInfoInput?.inputValue,
    ),
    anonymous: data?.anonymous,
    userNotLogged: data?.userNotLogged,
    recaptchaToken: data?.recaptchaToken,
    notificationTechnicalComplaintId: Number(
      data?.notificationTechnicalComplaintId?.inputValue,
    ),
    formUtils: [],
    cultureCode: i18next.language,
    answers: Array.isArray(questionNormalized[0])
      ? questionNormalized.reduce((prev: any, questionGroup: any) => {
        questionGroup.map((question: any) => prev.push(question));
        return prev;
      }, [])
      : questionNormalized,
  };
};

// eslint-disable-next-line  @typescript-eslint/no-explicit-any
export const PharmacyCreateBody = (data: any) => {
  return {
    hospitalCare: data?.hospitalCare,
    patientName: data?.patientName,
    patientIdentification: data?.noId ? data?.patientIdentification : undefined,
    patientBirthDate: data?.noId
      ? convertDate(data?.patientBirthDate)
      : undefined,
    // incidentDate: data?.incidentDate,
    genderId: data?.genderId?.inputValue
      ? Number(data?.genderId?.inputValue)
      : 3,
    shiftId: Number(data?.notificationMoreInfoInput?.inputValue),
    placeOfOccurrenceId: 1, // @TODO - Falta rever esses dados
    // placeOfOccurrenceId: data?.placeOfOccurrenceId,
    hospitalAdmissionId: data?.hospitalAdmissionId,
    unitAdmissionId: data?.unitAdmissionId,
    incidentUnitId: Number(data?.unitId?.inputValue),
    clinicalPharmacyCategoryId: Number(data?.pharmacyCategoryId?.inputValue),
    clinicalPharmacyOptionId: Number(
      data?.pharmacyCategoryOptionId?.inputValue,
    ),
    wasTheInterventionAccepted: /true/.test(
      data?.pharmacyInterventionAcceptance &&
      data?.pharmacyInterventionAcceptance.inputValue,
    ),
    doctorName: data?.pharmacyMedicNameInput,
    pharmaceuticalName: data?.pharmacyPharmacistNameInput,
    comments: data?.pharmacyCategoryComment,
    notifierName: data?.notifierName,
    notifierEmail: data?.notifierEmail,
    notifierUnitId: Number(data?.notifierUnitId?.inputValue),
    occupationId: Number(data?.occupationId?.inputValue),
    incidentDate: data?.notificationIntubationDateId,
    cultureCode: i18next.language,
    // safetyHuddleOrProactiveAction: data?.safetyHuddleOrProactiveAction,
    anonymous: data?.anonymous,
    notificationMoreInfoInput: Number(
      data?.notificationMoreInfoInput?.inputValue,
    ),
  };
};
